import { default as calculationNZAaJVk70ZMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailRTVZgVyPrKMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryFZlJlZKAsKMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_937ROujuYxUwMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listAv5Gt7O9zgMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingJW635JkzjHMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyoux6kN45pB3jMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upselld94ptqvUTyMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostjLnK1yoWlhMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankDqjerNq3F5Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniVmgNcqr7yJMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageEcoEwhK0PaMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testaEdem8k60nMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepageAt2Ppw2WKWMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articledueRbA3E2RMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsewyAy7zawpMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagBz4YOXOP46Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorNe2NEhWdZ8Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryRDrVyhZ7BGMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectioniIAk7PRyarMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlestUSALTkD4HMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryjCoVxY08awMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleMmkDkmkYxmMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectioncvkFKkeof8Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contact8BljwXYqPbMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationkntd4XAIw9Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationJuv0qz2o63Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youNZL5Tz0U8iMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detail6huW6SHSXxMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryOTmKiJTfSkMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45list4dFN0y5QjsMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculation3ZzYGap974Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youGk5zLd1H7zMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryE5PIwWvk8yMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listTq3E1BmZZ3Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detaili19WfMUYwTMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerdlbaxZqqR7Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryQ8stwZXPTcMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youE85QPJZdB6Meta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculation7fuRHTVFppMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listoUZVFjjWEJMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youwqimbzrPtTMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineX20RwGIxWqMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailknRHyZmBJYMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phonez3ZiNZSV1TMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerXinWWllDmtMeta } from "/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostjLnK1yoWlhMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankDqjerNq3F5Meta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniVmgNcqr7yJMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageEcoEwhK0PaMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testaEdem8k60nMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepageAt2Ppw2WKWMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articledueRbA3E2RMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsewyAy7zawpMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagBz4YOXOP46Meta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorNe2NEhWdZ8Meta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryRDrVyhZ7BGMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectioniIAk7PRyarMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlestUSALTkD4HMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageEcoEwhK0PaMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryjCoVxY08awMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleMmkDkmkYxmMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectioncvkFKkeof8Meta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectioncvkFKkeof8Meta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contact8BljwXYqPbMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationkntd4XAIw9Meta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationJuv0qz2o63Meta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youNZL5Tz0U8iMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detail6huW6SHSXxMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryOTmKiJTfSkMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45list4dFN0y5QjsMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculation3ZzYGap974Meta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youGk5zLd1H7zMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryE5PIwWvk8yMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listTq3E1BmZZ3Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detaili19WfMUYwTMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerdlbaxZqqR7Meta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryQ8stwZXPTcMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youE85QPJZdB6Meta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculation7fuRHTVFppMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listoUZVFjjWEJMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youwqimbzrPtTMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineX20RwGIxWqMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailknRHyZmBJYMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phonez3ZiNZSV1TMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerXinWWllDmtMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src1311874209/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]